import { Typography } from "antd";
import { useLocation } from "react-router-dom";
import { SettingsUsersTable } from "@/features/settings-users-table";
import { useCoordinator } from "@/shared/lib/hooks";
import { routes } from "@/shared/lib/react-router";
import { Breadcrumbs } from "@/shared/ui";
import { isUnifiedRoute } from "@shared/utils";
import "./supervision-admin-page.scss";

export const SupervisionAdminPage = () => {
  const { projectId, supervisionId } = useCoordinator();
  const location = useLocation();
  const isUnified = isUnifiedRoute(location.pathname);

  const breadcrumbs = [
    { path: routes.supervision.root(projectId), label: "Надзороне дело" },
    {
      path: routes.supervision.notifications(projectId, supervisionId),
      label: "«Бизнес-центр Невский»",
    },
    {
      path: routes.supervision.adminSettings(projectId, supervisionId),
      label: "Настройки администрирования",
    },
  ];

  return (
    <div className="supervision-admin-page">
      <Breadcrumbs routes={breadcrumbs} disableFirst={isUnified ? 3 : 0} />
      <div>
        <Typography.Title level={4}>
          Настройки администрирования
        </Typography.Title>
      </div>
      <div className="supervision-admin-page__tables">
        <SettingsUsersTable title="Администраторы" users={[]} />
        <SettingsUsersTable title="Подписанты" users={[]} />
      </div>
    </div>
  );
};

